import React from 'react'

import './preview.less'
import {ObsKeyToURL} from '../../api/utils'
import {LessonAnnex} from '../../api/course'
import {useHistory} from 'react-router-dom'
import {ArrowLeftOutlined} from '@ant-design/icons'
interface Props {
  previewFile: LessonAnnex
}
const PreivewVideo: React.FC<Props> = ({previewFile}) => {
  const history = useHistory()
  return (
    <div className="pdf-content-group">
      <div className="back-button-group" onClick={() => history.goBack()}>
        <ArrowLeftOutlined />
        <div className="second-title back-button-group-text">返回</div>
      </div>
      <div className="video-preview-outer">
        <video
          controls
          style={{width: '100%', height: '100%', outline: 'none'}}
          controlsList="nodownload"
          id="video"
          src={ObsKeyToURL(previewFile.url)}
        ></video>
      </div>
    </div>
  )
}
export default PreivewVideo
